import { render, staticRenderFns } from "./WalletBest.vue?vue&type=template&id=61cf04b9"
import script from "./WalletBest.vue?vue&type=script&lang=js"
export * from "./WalletBest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports